import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionGetLojas,
  actionSelectLoja,
} from "../../../features/dados-loja/lojas/slices";
import factoryOptionsFields from "../../../helpers/factory-fields";
import { getUser, setUser } from "../../../helpers/user";
import Select from "../../Select";
import { useAppSelector } from "../../../hooks/useAppSelector";

interface IPropsSelectLojas {
  idLoja?: string;
  lojas?: Array<any>;
  onChange?: any;
}

const SelectLojas = (props: IPropsSelectLojas) => {
  const dispatch = useDispatch();
  const { acesso } = getUser();
  const allowed = acesso.loja;

  const handleChange = async (ev: any) => {
    const {
      target: { value },
    } = ev;
    const usuario = getUser();
    usuario.usuario.idLoja = Number(value);

    try {
      await setUser(usuario);
    } catch (error) {
      console.error("Falha ao salvar o usuário na sessão.", error);
    }

    if (props.onChange) {
      props.onChange(ev);
    }

    dispatch(actionSelectLoja(value));
  };

  const resetSelects = () => {
    if (!props.onChange) {
      dispatch(actionSelectLoja(""));
    }
  };

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const lojas = useAppSelector((state) => state.getLojas.lojas);
  const regionalSelected = useAppSelector(
    (state) => state.getRegionais.regionalSelected
  );

  console.log("regionalSelected", regionalSelected);
  console.log("lojas", lojas);

  const optionsLojas = props.lojas || lojas;

  React.useEffect(() => {
    if (allowed) {
      dispatch(actionGetLojas());
    }
  }, [regionalSelected]);

  if (!allowed) {
    return null;
  }

  return (
    <Select
      options={factoryOptionsFields.lojas(optionsLojas)}
      label="Lojas/Site"
      name="idLoja"
      onChange={handleChange}
      value={props.idLoja || lojaSelected || ""}
      size="sm"
    />
  );
};

export default SelectLojas;
